import React, {useCallback, useEffect, useState} from 'react';
import { LineChart, lineElementClasses } from '@mui/x-charts/LineChart';
import Box from '@mui/joy/Box';



/////////////////////// API
import { getlineChart } from '../../Api/common'




// let uData = [4000, 3000, 2000, 2780, 1890, 2390, 3490];
// let pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300];
// // const amtData = [2400, 2210, 0, 2000, 2181, 2500, 2100];
// let xLabels = [
//   'Page A',
//   'Page B',
//   'Page C',
//   'Page D',
//   'Page E',
//   'Page F',
//   'Page G',
// ];

export default function StackedAreaChart() {

  const [uData, setUData] = useState([])
  const [pData, setPData] = useState([])
  const [xLabels, setXLabels] = useState([])
  const [seriesData, setSeriesData] = useState([])

  

  const linechartData = useCallback( async () => {
    const res = await getlineChart();
    if(res){
      setXLabels(res.data.days)	
      let dataLineChart = [
        { data: res.data.Udata, label: 'افراد', area: true, stack: 'total', showMark: false },
        { data: res.data.Cdata, label: 'شركات', area: true, stack: 'total', showMark: false },
        { data: res.data.Bdata, label: 'بنوك', area: true, stack: 'total', showMark: false },
      ]
      	
      setSeriesData(dataLineChart)
    }
  },[])

  useEffect(() => {
    linechartData()
  }, [linechartData])

  return (
    <Box sx={{direction:'ltr', marginTop:'24px'}}>

      <LineChart
        height={300}
        series={seriesData}
        xAxis={[{ scaleType: 'point', data: xLabels }]}
        sx={{
          [`& .${lineElementClasses.root}`]: {
            display: 'none',
          },
        }}
      />
    </Box>
  );
}